import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    nume: "",
    prenume: "",
    adresa: "",
    telefon: "",
    tipProprietate: "apartament",
    locuita: "da",
    mp: "",
    serviciu: "",
    detalii: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Generate WhatsApp message
    const message = `Bună ziua! Doresc să solicit o ofertă pentru servicii de instalații sanitare.

📋 Date personale:
• Nume: ${formData.nume}
• Prenume: ${formData.prenume}
• Adresă: ${formData.adresa}
• Telefon: ${formData.telefon}

🏠 Detalii proprietate:
• Tip: ${formData.tipProprietate === "apartament" ? "Apartament" : "Casă"}
• Locuită: ${formData.locuita === "da" ? "Da" : "Nu"}
${formData.mp ? `• Suprafață: ${formData.mp} m²` : ""}

🔧 Serviciu solicitat:
${formData.serviciu}

${formData.detalii ? `📝 Detalii suplimentare:\n${formData.detalii}` : ""}

Vă mulțumesc!`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/40744476911?text=${encodedMessage}`;
    
    window.open(whatsappUrl, "_blank");
  };

  return (
    <main className="bg-gradient-to-b from-sky-50 via-white to-white text-slate-900">
      <section className="mx-auto max-w-4xl px-4 py-10 md:py-14">
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight md:text-4xl">
            Solicită Ofertă - Contact
          </h1>
          <p className="mt-3 text-lg text-slate-700">
            Completează formularul pentru o ofertă personalizată sau sună direct la <strong>0744 476 911</strong>. 
            Oferim consultanță gratuită și răspundem rapid.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {/* Form */}
          <div className="md:col-span-2">
            <form onSubmit={handleSubmit} className="rounded-2xl border bg-white p-6 shadow-sm md:p-8">
              <div className="grid gap-6">
                {/* Nume & Prenume */}
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label htmlFor="nume" className="mb-2 block text-sm font-medium text-slate-700">
                      Nume *
                    </label>
                    <input
                      type="text"
                      id="nume"
                      name="nume"
                      required
                      value={formData.nume}
                      onChange={handleChange}
                      className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                    />
                  </div>
                  <div>
                    <label htmlFor="prenume" className="mb-2 block text-sm font-medium text-slate-700">
                      Prenume *
                    </label>
                    <input
                      type="text"
                      id="prenume"
                      name="prenume"
                      required
                      value={formData.prenume}
                      onChange={handleChange}
                      className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                    />
                  </div>
                </div>

                {/* Adresa */}
                <div>
                  <label htmlFor="adresa" className="mb-2 block text-sm font-medium text-slate-700">
                    Adresă *
                  </label>
                  <input
                    type="text"
                    id="adresa"
                    name="adresa"
                    required
                    value={formData.adresa}
                    onChange={handleChange}
                    placeholder="Strada, număr, oraș"
                    className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                  />
                </div>

                {/* Telefon */}
                <div>
                  <label htmlFor="telefon" className="mb-2 block text-sm font-medium text-slate-700">
                    Număr de telefon *
                  </label>
                  <input
                    type="tel"
                    id="telefon"
                    name="telefon"
                    required
                    value={formData.telefon}
                    onChange={handleChange}
                    placeholder="+40 xxx xxx xxx"
                    className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                  />
                </div>

                {/* Tip proprietate & Locuită */}
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label htmlFor="tipProprietate" className="mb-2 block text-sm font-medium text-slate-700">
                      Tip proprietate *
                    </label>
                    <select
                      id="tipProprietate"
                      name="tipProprietate"
                      required
                      value={formData.tipProprietate}
                      onChange={handleChange}
                      className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                    >
                      <option value="apartament">Apartament</option>
                      <option value="casa">Casă</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="locuita" className="mb-2 block text-sm font-medium text-slate-700">
                      Locuită *
                    </label>
                    <select
                      id="locuita"
                      name="locuita"
                      required
                      value={formData.locuita}
                      onChange={handleChange}
                      className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                    >
                      <option value="da">Da</option>
                      <option value="nu">Nu</option>
                    </select>
                  </div>
                </div>

                {/* Suprafață */}
                <div>
                  <label htmlFor="mp" className="mb-2 block text-sm font-medium text-slate-700">
                    Suprafață (m²) - opțional
                  </label>
                  <input
                    type="number"
                    id="mp"
                    name="mp"
                    value={formData.mp}
                    onChange={handleChange}
                    placeholder="ex: 80"
                    className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                  />
                </div>

                {/* Serviciu */}
                <div>
                  <label htmlFor="serviciu" className="mb-2 block text-sm font-medium text-slate-700">
                    Ce fel de instalații sanitare aveți nevoie? *
                  </label>
                  <textarea
                    id="serviciu"
                    name="serviciu"
                    required
                    value={formData.serviciu}
                    onChange={handleChange}
                    rows="3"
                    placeholder="ex: Instalare centrală termică, montare radiatoare, instalații baie completă..."
                    className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                  />
                </div>

                {/* Detalii suplimentare */}
                <div>
                  <label htmlFor="detalii" className="mb-2 block text-sm font-medium text-slate-700">
                    Detalii suplimentare - opțional
                  </label>
                  <textarea
                    id="detalii"
                    name="detalii"
                    value={formData.detalii}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Orice alte informații care ne-ar putea ajuta..."
                    className="w-full rounded-lg border border-slate-300 px-4 py-2.5 text-slate-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/20"
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="flex items-center justify-center gap-2 rounded-xl bg-green-600 px-6 py-3 font-medium text-white shadow-sm transition hover:bg-green-700"
                >
                  <IconWhatsApp className="h-5 w-5" />
                  Trimite pe WhatsApp
                </button>
              </div>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <div className="rounded-2xl border bg-white p-6 shadow-sm">
              <h3 className="text-lg font-semibold">Contact Direct</h3>
              <div className="mt-4 space-y-3">
                <ContactItem href="tel:+40744476911" label="+40 744 476 911">
                  <IconPhone />
                </ContactItem>
                <ContactItem href="https://wa.me/40744476911" label="WhatsApp" external>
                  <IconWhatsAppBlue />
                </ContactItem>
                <ContactItem href="mailto:marius.pocei@gmail.com" label="marius.pocei@gmail.com">
                  <IconEmail />
                </ContactItem>
                <ContactItem label="Arad, România">
                  <IconPin />
                </ContactItem>
              </div>
            </div>

            <div className="rounded-2xl border bg-sky-50 p-6 shadow-sm">
              <h4 className="text-lg font-semibold text-sky-900">Program & Zonă</h4>
              <p className="mt-2 text-sm text-sky-900/90">
                <strong>Program:</strong><br />
                Luni - Vineri: 08:00 - 18:00
              </p>
              <p className="mt-3 text-sm text-sky-900/90">
                <strong>Zonă deservită:</strong><br />
                Arad și împrejurimi
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

function ContactItem({ href, label, children, external = false }) {
  const Comp = href ? "a" : "div";
  const props = href ? { href, ...(external ? { target: "_blank", rel: "noreferrer" } : {}) } : {};
  return (
    <Comp {...props} className="group inline-flex items-center gap-3 rounded-xl p-2 pr-3 transition hover:bg-sky-50">
      <span className="grid h-9 w-9 place-items-center rounded-lg bg-sky-100 text-sky-700">{children}</span>
      <span className="text-sm text-slate-800 group-hover:text-slate-900">{label}</span>
    </Comp>
  );
}

function IconPhone({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 16.5v2a2.5 2.5 0 0 1-2.7 2.5 16.8 16.8 0 0 1-7.3-3.1 16.6 16.6 0 0 1-5.9-5.9A16.8 16.8 0 0 1 2 4.7 2.5 2.5 0 0 1 4.5 2h2A1.5 1.5 0 0 1 8 3.2c.2 1 .6 2 .9 2.8.3.8.1 1.6-.4 2.1L7 9.7a13.8 13.8 0 0 0 7.3 7.3l1.6-1.5c.5-.5 1.3-.7 2.1-.4.9.3 1.8.7 2.8.9A1.5 1.5 0 0 1 21 16.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconWhatsApp({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
    </svg>
  );
}

function IconWhatsAppBlue({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" role="img">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        fill="#FFFFFF"
        d="M16.14 13.22c-.21-.1-1.24-.61-1.43-.68-.19-.07-.33-.1-.47.1s-.54.68-.66.82c-.12.14-.24.15-.45.05-.21-.1-.9-.33-1.72-1.05-.64-.55-1.08-1.22-1.21-1.43-.13-.21-.01-.33.09-.43.1-.1.21-.24.31-.36.1-.12.14-.21.21-.35.07-.14.03-.26-.02-.36-.05-.1-.47-1.13-.64-1.55-.17-.41-.34-.35-.47-.36l-.4-.01c-.14 0-.36.05-.55.26-.19.21-.73.71-.73 1.73s.75 2 .86 2.14c.1.14 1.49 2.28 3.62 3.2 2.13.92 2.13.62 2.51.6.38-.02 1.24-.5 1.41-.98.17-.48.17-.89.12-.98-.05-.09-.19-.14-.4-.24Z"
      />
    </svg>
  );
}

function IconPin({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 21s7-4.2 7-10a7 7 0 1 0-14 0c0 5.8 7 10 7 10Z" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="11" r="2.4" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function IconEmail({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
